/**
 * Reorders one element of an array, immutably. Shared by the widget assemblers'
 * `moveChatBot` / `moveElement` / `moveSocial` reorder sugar (drag-and-drop in
 * the control panel).
 */
export function arrayMove<T>(arr: readonly T[], from: number, to: number): T[] {
    const next = [...arr];
    const [moved] = next.splice(from, 1);
    next.splice(to, 0, moved);

    return next;
}
